import styled from 'styled-components';

const LogoImg = styled.img`
  @media (max-width: 767px) {
    width: 190px;
  }
`;

export default LogoImg;
